import { proxy, useSnapshot } from 'valtio';

import { BoardSoundThemes } from '@exports/ChessBoard';
import { getLocalStorage } from '@libs/storage';

const LOCAL_STORAGE_KEY = 'boards-sounds';
const LOCAL_STORAGE = getLocalStorage();

const BOARD_SOUNDS_STORE = proxy({
  boardSounds: (LOCAL_STORAGE.getItem(LOCAL_STORAGE_KEY) ?? 'default') as BoardSoundThemes,
  setBoardSounds: (t: BoardSoundThemes) => {
    BOARD_SOUNDS_STORE.boardSounds = t;
    LOCAL_STORAGE.setItem(LOCAL_STORAGE_KEY, t);
  },
});

export function useBoardSounds() {
  return useSnapshot(BOARD_SOUNDS_STORE);
}
